import { HazardTypes } from '../../constants';
import { HazardType } from './hazard.types';

export const HAZARD_TYPE_TO_TRANS_KEY: Record<HazardType, string> = {
  [HazardTypes.hazmat]: 'hazard.types.hazmat',
  [HazardTypes.landslide]: 'hazard.types.landslide',
  [HazardTypes.damLeveeFailure]: 'hazard.types.damLeveeFailure',
  [HazardTypes.roadWashout]: 'hazard.types.roadWashout',
  [HazardTypes.swiftWater]: 'hazard.types.swiftWater',
  [HazardTypes.standingWater]: 'hazard.types.standingWater',
  [HazardTypes.other]: 'hazard.types.other',
};
